// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-component {
  margin: 10px 0 10px;
  margin-bottom: 10px;
  background: transparent !important;
  padding: 0px 15px 0px;
}

.title-row {
  padding-top: 10px;
}
@media (max-width: 400px) {
  .title-row {
    padding-top: 0;
  }
}

.title {
  font-size: 22px;
  font-family: Tusker;
  display: flex;
  align-self: center;
  text-transform: uppercase;
  margin: 0;
  color: #fff;
}

.custom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.custom div {
  background: url('tip_custom_background.svg') no-repeat center/99% 100%;
}
.custom div span {
  font-family: Tusker, sans-serif;
  font-size: 10px;
  color: var(--ion-color-primary);
  display: block;
  margin: 11px 12px;
}

.tip {
  margin: 5px;
  background: var(--ion-color-secondary);
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 2px solid var(--ion-color-secondary);
  font-size: 14px;
  border-radius: 7px;
}
.tip:first-of-type {
  margin-left: 0;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip > * {
  margin: 0;
  padding: 0;
}
.tip.selected {
  border: 2px solid white;
}
.tip.selected-custom {
  border: 2px solid white;
}

.sum {
  font-family: Tusker;
  font-size: 14px;
  color: #fff;
}

.percent {
  font-family: AppFontBold;
  size: 12px;
  color: #fff;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  height: 35px;
  width: 35px;
  transform: translateY(-50%);
}
.custom-tip-row ion-item {
  color: white;
  font-family: "POPINSBOLD", sans-serif;
  --padding-start: 18px !important;
}

.tip-img {
  width: 30px;
  height: 30px;
  margin-bottom: 5px !important;
}

.info-wraper {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-wraper .info {
  font-family: AppFontBold;
  font-size: 12px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,qBAAA;AAFF;;AAIA;EACE,iBAAA;AADF;AAGE;EAHF;IAII,cAAA;EAAF;AACF;;AAGA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EAEA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AADF;AAEE;EACE,sEAAA;AAAJ;AAEI;EACE,+BAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,iBAAA;AAAN;;AAKA;EACE,WAAA;EACA,sCAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAME;EACE,SAAA;EACA,UAAA;AAJJ;AAOE;EACE,uBAAA;AALJ;AASE;EACE,uBAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,eAAA;EACA,WAAA;AARF;;AAWA;EACE,wBAAA;EACA,UAAA;EACA,WAAA;AARF;;AAWA;EACE,8BAAA;AARF;AAUE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;AARJ;AAWE;EACE,YAAA;EACA,qCAAA;EACA,gCAAA;AATJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AAXF;;AAcA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXF;AAYE;EACE,wBAAA;EACA,eAAA;EACA,YAAA;AAVJ","sourcesContent":["@import \"../../../theme/mixins\";\n\n\n.tip-component {\n  margin: 10px 0 10px;\n  margin-bottom: 10px;\n  background: transparent !important ;\n  padding:  0px 15px 0px;\n}\n.title-row {\n  padding-top: 10px;\n\n  @media (max-width: 400px) {\n    padding-top: 0;\n  }\n}\n\n.title {\n  font-size: 22px;\n  font-family: Tusker;\n  display: flex;\n  align-self: center;\n  text-transform: uppercase;\n  margin: 0;\n\n  color: #fff;\n}\n\n.custom {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  div {\n    background: url(../../../assets/tabilo/tips/tip_custom_background.svg) no-repeat center / 99% 100%  ;\n\n    span {\n      font-family: Tusker, sans-serif;\n      font-size: 10px;\n      color: var(--ion-color-primary);\n      display: block;\n      margin: 11px 12px;\n    }\n  }\n}\n\n.tip {\n  margin: 5px;\n  background:  var(--ion-color-secondary);\n  box-sizing: border-box;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border: 2px solid var(--ion-color-secondary);\n  font-size: 14px;\n  border-radius: 7px;\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n\n  > * {\n    margin: 0;\n    padding: 0;\n  }\n\n  &.selected {\n    border: 2px solid white;\n\n  }\n\n  &.selected-custom {\n    border: 2px solid white;\n  }\n}\n\n.sum {\n  font-family: Tusker;\n  font-size: 14px;\n  color: #fff;\n}\n\n.percent {\n  font-family: AppFontBold;\n  size: 12px;\n  color: #fff;\n}\n\n.custom-tip-row {\n  justify-content: space-between;\n\n  ion-icon {\n    cursor: pointer;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    height: 35px;\n    width: 35px;\n    transform: translateY(-50%);\n\n  }\n  ion-item {\n    color: white;\n    font-family: 'POPINSBOLD', sans-serif;\n    --padding-start: 18px !important;\n  }\n}\n.tip-row{\n}\n.tip-img {\n  width: 30px;\n  height: 30px;\n  margin-bottom: 5px !important;\n}\n\n.info-wraper {\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .info {\n    font-family: AppFontBold;\n    font-size: 12px;\n    color: white;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
